import { Record as record } from 'immutable';
import Joi from 'joi';

import t from '../../lib/I18n';
import { Validation } from '../../constants/AppConstants';
import ValidationMixin from '../ValidationMixin';

const defaults = {
    postcode: null
};

class PostcodeLookUp extends record(defaults) {
    getSchema () {
        return {
            postcode: Joi.string().trim().regex(Validation.postcode).allow([ null, '' ]).options({
                language: {
                    any: {
                        empty: t('alertmessage.badPostCode')
                    },
                    string: {
                        base: t('alertmessage.badPostCode'),
                        regex: {
                            base: t('alertmessage.badPostCode')
                        }
                    }
                }
            })
        };
    }
}

Object.assign(PostcodeLookUp.prototype, ValidationMixin);

export default PostcodeLookUp;



// WEBPACK FOOTER //
// ./src/records/customer/PostcodeLookUp.js